// import React, { useState } from "react";
// import { Helmet } from "react-helmet"; // Helmet import

import RandingStyle10 from "../../randing/RandingStyle10";

function Randing104({ urlCode, urlCodeSettingId }) {
  return (
    <RandingStyle10
      urlCode={urlCode}
      urlCodeSettingId={urlCodeSettingId}
      img1Path={`${process.env.REACT_APP_CDN_BASE}/images/104/20250225_01.jpg`}
      img2Path={`${process.env.REACT_APP_CDN_BASE}/images/104/20250225_02.gif`}
      img3Path={`${process.env.REACT_APP_CDN_BASE}/images/104/20250225_03.jpg`}
      // img4Path={`${process.env.REACT_APP_CDN_BASE}/images/097/250213_04.jpg`}
      postBTN={`${process.env.REACT_APP_CDN_BASE}/images/postBtns/blue/applyButton4.png`}
      qTitleColor="#0166ff"
      qOptionColor="blue"
      formFieldColor="white"
      companyName="본원"
      privacyMessage="개인정보수집에 동의하시는 분만 '신청하기'버튼을 눌러주세요."
      // footerPath={`${process.env.REACT_APP_CDN_BASE}/images/footer/ggul.jpg`}
      eventDates={true}
    />
  );
}

export default Randing104;
